/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Timecode_InInputs */



/**
* | output |
* | --- |
* | "Timecode In" |
*
* @param {Ccsl_Export_Header_Timecode_InInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_timecode_in = /** @type {((inputs?: Ccsl_Export_Header_Timecode_InInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Timecode_InInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Timecode entree")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timecode In")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codice temporale in entrata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ввод временного кода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Entrada de código de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间码输入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコード入力")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड में")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Código de tempo em")
	return /** @type {LocalizedString} */ ("Timecode In")
});